import { Observable , of } from 'rxjs';
import { Loggable } from '@services/strategy-pattern-login/loggable';
import { Injectable } from '@angular/core';
import { ConfigService } from '@services/webFeeder/config.service';
import { Constants } from '@utils/constants';
import { HttpClient } from '@angular/common/http';
import { AppUtils } from '@utils/app.utils';
import { HttpService } from '@services/http-service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthAdapterService implements Loggable {

  constructor(
    private _configService: ConfigService,
    private _httpsvc: HttpClient,
    private _httpService: HttpService,
  ) { }

  login(username: string, password: string, profile?: any) {
    throw new Error('Method not implemented.');
  }

  loginO(username: string, password: string, profile?: any) {
    throw new Error('Method not implemented.');
  }

  brokerServiceLogin(username: string, password: string, broker: string) {
    throw new Error('Method not implemented.');
  }

  brokerServiceLogout() {
    const params: any = {};
    params.refresh_token = this._configService.getTokenRefreshApi();
    return this._httpService
      .doPost(this._configService.getApiWebFeederRestAuthAdapter() + '/logout', null, params, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  brokerServiceInternalLogout() {
    const params: any = {};
    params.refresh_token = this._configService.getTokenRefreshApi();
    return this._httpService
      .doPost(this._configService.getApiWebFeederRestAuthAdapter() + '/logout', null, params, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  recoverPassword(email: string, type: number, client?: boolean) {
    throw new Error('Method not implemented.');
  }

  changePassword(token: string, type: number, newPassword: string, broker: string) {
    throw new Error('Method not implemented.');
  }

  difusionChangePassword(login: string, oldPassword: string, newPassword: string, isPasswordExpired: boolean) {
    throw new Error('Method not implemented.');
  }

  clientRegisterSimulator(username: string, password: string) {
    throw new Error('Method not implemented.');
  }

  isTokenExpired() {
    return new Date() >= AppUtils.strToDateTime(this._configService.getTokenExpiration()) ? true : false;
  }

  refresh() {
    const params: any = {};
    params.refresh_token = this._configService.getTokenRefreshApi();
    return this._httpsvc.post(this._configService.getApiWebFeederRestAuthAdapter() + '/refresh_token',
      JSON.stringify(params), Constants.httpOptions);
  }

  resetSignature(signature: string, newSignature: string) {
    throw new Error('Method not implemented.');
  }

  forgotSignature() {
    throw new Error('Method not implemented.');
  }

  advisorInfo(login?: string) {
    throw new Error('Method not implemented.');
  }

  advisorChangePassword(currentPassword: string, newPassword: string, guid?: string, advisorId?: number) {
    throw new Error('Method not implemented.');
  }

  loginToken(token: string) {
    throw new Error('Method not implemented.');
  }

  loginAuth(code: string, login: any, second_auth_option: string, answer: string, username?: string, password?: string) {
    if (!code && !second_auth_option && !answer && !username && !password) {
      return of('Parâmetros incorretos.');
    }
    const params: any = {};
    if (code) {
      params.code = code;
      params.login = login;
      params.grant_type = 'authorization_code';
    } else if (username && password) {
      params.grant_type = 'password';
      params.user_name = username;
      params.password = password;
      params.encrypt_password = true;
    }

    if (second_auth_option) {
      params.second_auth_option = second_auth_option;
    }

    if (answer) {
      params.answer = answer;
    }

    params.app_name = Constants.DEFAULT_APP_NAME_ADAPTER;
    return this._httpService
      .doPost(this._configService.getApiWebFeederRestAuthAdapter() + '/token', null, params, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  loginWS(guidUser?: string) {
    return this._httpService.doGet(this._configService.getApiWebFeederRestAuthAdapter() + '/ws_token');
  }

  info() {
    const params: any = {};
    params.type = Constants.DEFAULT_APP_NAME_ADAPTER;
    return this._httpsvc.post(this._configService.getApiWebFeederRestAuthAdapter() + '/info',
      JSON.stringify(params), Constants.httpOptions);
  }

  validateTokenAdapter() {
    return this._httpService.doGet(this._configService.getApiWebFeederRestAuthAdapter() + '/validate_token');
  }

}
